package com.patronat.top.features.venues.domain.usecase

import com.patronat.top.core.dispatchers.DispatcherProvider
import com.patronat.top.core.domain.models.DomainResult
import com.patronat.top.domain.usecase.BaseUseCase
import com.patronat.top.dto.VenueAssigneesResponse
import com.patronat.top.features.venues.domain.repository.VenuesRepository
import com.patronat.top.features.venues.domain.usecase.command.GetVenueAssigneesCommand

class GetVenueAssigneesUseCase(
    private val venuesRepository: VenuesRepository,
    dispatcherProvider: DispatcherProvider
) : BaseUseCase<GetVenueAssigneesCommand, DomainResult<VenueAssigneesResponse>>(
    dispatcher = dispatcherProvider.io
) {
    override suspend fun doWork(command: GetVenueAssigneesCommand): DomainResult<VenueAssigneesResponse> {
        return venuesRepository.getVenueAssignees()
    }
}
